<!-- DOC: https://bootstrap-vue.org/docs/components/form-select -->
<template>
  <b-form-group
    :label="label"
    :label-size="size"
    :label-class="`font-weight-bold ${(validate.required === true || (typeof validate === 'string' && validate.search('required') !== -1) ? 'is-required' : '')}`"
  >
    <ValidationProvider
      v-slot="validationContext"
      ref="inputValidation"
      :name="name"
      :rules="validate"
      :mode="validationMode"
    >
      <v-select
        class="style-chooser"
        :options="options"
        label="text"
        v-model="_value"
        placeholder="Seleccionar..."
        :reduce="(option) => option.value"
        @change="onchange"
      >
        <template #no-options>Sin opciones</template>
      </v-select>
      <!-- <b-select
        v-model="_value"
        :name="name"
        :options="options"
        :state="getValidationState(validationContext)"
        :size="size"
        @change="onchange"
      >
        <template v-slot:first>
          <b-form-select-option :value="null" :disabled="validate === 'required'">{{ placeholder }}</b-form-select-option>
        </template>
      </b-select> -->
      <b-form-invalid-feedback
        v-if="showErrorMessage"
        :state="validationContext.errors.length === 0"
      >
        {{ validationContext.errors.join('. ') }}
      </b-form-invalid-feedback>
    </ValidationProvider>
  </b-form-group>
</template>

<script>
  export default {
    name: 'InputSelectComponent',
    props: {
      name: {
        type: String,
        required: true,
      },
      options: {
        type: Array,
        required: true,
        default: () => []
      },
      label: {
        type: String,
        required: false,
        default: ''
      },
      onchange: {
        type: Function,
        required: false,
        default: () => {}
      },
      placeholder: {
        type: String,
        required: false,
        default: 'Selecciona una opción'
      },
      validate: {
        type: [String, Object],
        required: false,
        default: ''
      },
      value: {
        type: [String, Number],
        required: false,
        default: null,
      },
      validationMode: {
        type: String,
        required: false,
        default: 'aggressive' // passive, lazy, eager (https://vee-validate.logaretm.com/v3/guide/interaction-and-ux.html#interaction-modes)
      },
      size: {
        type: String,
        required: false,
        default: ''
      },
      showErrorMessage: {
        type: Boolean,
        required: false,
        // eslint-disable-next-line vue/no-boolean-default
        default: true,
      }
    },
    computed: {
      _value: {
        get () {
          // setTimeout(() => {
          //   this.$refs['inputValidation'].validate()
          // }, 300)
          return this.value
        },
        set (value) {
          this.$emit('update:value', value)
          this.$emit('input', value)
        }
      }
    },
    methods: {
      getValidationState({ validated, valid = null}) {
        return validated ? valid : null
      }
    },
  }
</script>

<style lang="scss" scoped>
  .custom-select {
    background-image: url('../../assets/images/proximo.png'),
    linear-gradient(to bottom, #ffffff 0%, #ffffff 100%) !important;
    background-repeat: no-repeat, repeat;
    background-position: right 0.7em top 50%, 0 0;
    background-size: 0.65em auto, 100%;
  }

  .custom-select option {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 11px #00000029;
    border: 1px solid #E2E2E2;
    border-radius: 4px;
    font-weight: 400;
    font-size: 13px;
    padding-left: 12.53px;
    padding-top: 15.5px;
    margin-bottom: 9.65px;
  }

    /* Tamaño del scroll */
  .custom-select::-webkit-scrollbar {
    width: 6px;
    height: 6px !important;
  }

  /* Estilos barra (thumb) de scroll */
  .custom-select::-webkit-scrollbar-thumb {
    background: #124884;
    border-radius: 6px;
    height: 5px !important;
  }

  .custom-select::-webkit-scrollbar-thumb:active {
    background-color: #999999;
  }

  .custom-select::-webkit-scrollbar-thumb:hover {
    background: #124884;
    box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
  }

  /* Estilos track de scroll */
  .custom-select::-webkit-scrollbar-track {
    background: #f2f2f2;
  }

  .custom-select::-webkit-scrollbar-track:hover,
  .custom-select::-webkit-scrollbar-track:active {
    background: #f2f2f2;
  }
</style>